import { forceInt, getCurrenLocaleObj } from "../functions";

$(function() {
    const $car2db = $('.car2db');
    if (!$car2db.length) return;

    const currenLocaleObj = getCurrenLocaleObj();

    var selectedOptions = [];

    const clearAllChildren = function($this) {
        const index = forceInt($this.data('index')),
            selectsWrapper = $this.closest('.car2db-selects');
        let n = index,
            selectField = selectsWrapper.find('.car2db-select[data-index="' + (n+1) + '"]');
        // console.log(selectField.data('type'), selectField);
        if (selectField.length) {
            while (selectField.length) {
                const parent = selectField.closest('.car2db-select-wrapper'),
                    skipClear = forceInt(selectField.data('skip-clear'));

                parent.hide();

                if (!skipClear) {
                    selectField.data('options-count', -1);
                    selectField.find('option').remove();
                    selectField.trigger('chosen:updated');
                }

                // console.log('clearing', selectField.data('title'));

                n++;
                selectField = selectsWrapper.find('.car2db-select[data-index="' + (n+1) + '"]');
            }
        }
    };

    const selectionCompleteCheck = function(selectEl) {
        const selectFields = selectEl.closest('.car2db-selects').find('.car2db-select');
        let complete = true;

        // console.log('selectionCompleteCheck start');
        selectFields.each(function() {
            const $this = $(this),
                val = forceInt($this.val()),
                count = forceInt($this.data('options-count'));

            if ((count > 0) && !val) {
                complete = false;
            }

            // console.log(count, val, $this.data('title'));
        });
        // console.log('complete', complete);
        // console.log('selectionCompleteCheck end');

        return complete;
    };

    var getSelectedOptions = function(panelEl) {
        const selectedOptions = [];

        panelEl.find('.car2db-specs').find('input, select').each(function() {
            const $this = $(this),
                fieldType = $this.prop('nodeName').toLowerCase(),
                type = (fieldType == 'input' ? $this.attr('type') : fieldType),
                selected = $this.prop('checked'),
                optionID = forceInt($this.data('option-id')),
                multiSelect = ((type === 'checkbox') || (type === 'select' && $this.attr('multiple')) ? true : false);

            if (optionID > 0) {
                let value = '',
                    valueID = 0,
                    textFieldValue = false;

                if ((type === 'radio' || type === 'checkbox') && selected) {
                    value = $this.data('title');
                    valueID = forceInt($this.val());
                } else if (type === 'text' || type === 'number') {
                    value = $this.val();
                    textFieldValue = value;
                } else if (type === 'select') {
                    if (multiSelect) {
                        valueID = [];
                        $this.find('option:selected').each(function() {
                            valueID.push(forceInt(this.value));
                            if (value !== '') value += ' | ';
                            value += this.text
                        });
                    } else {
                        value = $this.find('option:selected').text();
                        valueID = forceInt($this.val());
                    }

                    if (valueID === 0) {
                        value = '';
                    }
                }

                if (value) {
                    if ($.isArray(valueID)) { // for multi selects
                        valueID.forEach(id => {
                            selectedOptions.push({
                                OptionID: optionID,
                                ValueID: id,
                                TextFieldValue: (textFieldValue !== false ? textFieldValue : ''),
                            });
                        });
                    } else {
                        const option = {
                            OptionID: optionID,
                            ValueID: valueID,
                            TextFieldValue: (textFieldValue !== false ? textFieldValue : ''),
                        };
                        const selectedOption = selectedOptions.find((selectedOption) => selectedOption.OptionID === optionID);
                        if (selectedOption && !multiSelect) {
                            selectedOption.OptionID = option.OptionID;
                            selectedOption.ValueID = option.ValueID;
                            if (textFieldValue !== false) selectedOption.TextFieldValue = option.TextFieldValue; // Don't want the select to override the value from the text input associsated with the same option
                        } else {
                            selectedOptions.push(option);
                        }
                    }

                }
            }
        });

        // console.log(JSON.stringify(selectedOptions));

        return selectedOptions;
    };

    var getVisibleEl = function($this) {
        const type = getFieldType($this);
        let visibleEl = $this;

        if (type === 'select') {
            const chosenContainer = $this.siblings('.chosen-container');
            if (chosenContainer.length) {
                visibleEl = chosenContainer;
            }
        }

        return visibleEl;
    }

    var applyParsley = function($this) {
        const panelBody = $this.parents('.panel-body'),
            type = getFieldType($this),
            errorMessagesField = panelBody.find('.car2db-selects-error'),
            visibleEl = getVisibleEl($this),
            errorsMessagesDisabled = visibleEl.hasClass('chosen-container') ? true : false; // if chosen is being used then disable errors

        $this.parsley({
            'required': true,
            'errorsMessagesDisabled': errorsMessagesDisabled,
        }).on('field:validated', function() {
            const $this = this.$element,
                type = getFieldType($this),
                visibleEl = getVisibleEl($this),
                errorMessagesField = $this.parents('.car2db-select-wrapper').find('.car2db-select-wrapper__error');
            let errorMessage = hpaTranslatedtext.car2DB.validation.pleaseSelectA; // Please select a
            if (type === 'text') {
                errorMessage = hpaTranslatedtext.car2DB.validation.pleaseEnterThe; // Please enter the
            }

            if (!this.isValid()) {
                visibleEl.addClass('error');

                $('html, body').animate({
                    scrollTop: visibleEl.offset().top - 20
                });

                errorMessage += ' ' + $this.data('title');
                if (errorMessagesField.length) {
                    errorMessagesField.text(errorMessage);
                    errorMessagesField.show();
                }
            } else {
                visibleEl.removeClass('error');
                if (errorMessagesField.length) {
                    errorMessagesField.text('');
                    errorMessagesField.hide();
                }
            }
        });
    };

    var getFieldType = function($this) {
        const fieldType = $this.prop('nodeName').toLowerCase(),
            type = (fieldType == 'input' ? $this.attr('type') : fieldType);

        return type;
    }

     // only setup for radio fields as the value and select fields as the option
    var dependentOptionsToggle = function(panelEl) {
        const msID = panelEl.data('car2db-ms-id'),
            dependentValues = panelEl.find('[data-dependent-option-id]');

        if (dependentValues.length) {
            dependentValues.each(function() {
                const $this = $(this),
                    isSelected = $this.prop('checked'),
                    fieldType = $this.prop('nodeName').toLowerCase(),
                    type = (fieldType == 'input' ? $this.attr('type') : fieldType),
                    dependentOptionID = forceInt($this.data('dependent-option-id')),
                    dependentOption = $('#car2db-ms-' + msID + '-option-' + dependentOptionID);

                if (type === 'radio') {
                    if (dependentOption.length) {
                        if (isSelected) {
                            dependentOption.removeClass('car2db-select-option--hidden');
                        } else {
                            dependentOption.addClass('car2db-select-option--hidden');
                            dependentOption.find('option:selected').prop('selected', false);
                        }
                    }
                }
            });
        }
    };

    var updateMemberSelections = function() {
        const memberSelections = $('.car2db-ms');
        if (memberSelections.length && typeof car2DBMemberSelections !== 'undefined') {
            memberSelections.each(function(index) {
                updateMemberSelection($(this));
            });
        }
    };
    var updateMemberSelection = function($this) {
        const msId = forceInt($this.data('car2db-ms-id')),
            specs = $this.find('.car2db-specs');

        if (msId > 0) {
            const dropdownFields = $this.find('.car2db-select'),
                selection = car2DBMemberSelections.find(selection => selection.ID === msId);

            if (selection) {
                const isCustomInput = (selection.MakeCustom && selection.ModelCustom ? true : false);
                if (isCustomInput) {
                    const customMakeField = $this.find('.car2db-custom-make'),
                        customModelField = $this.find('.car2db-custom-model');

                    customMakeField.val(selection.MakeCustom);
                    customModelField.val(selection.ModelCustom);
                }

                if (dropdownFields && dropdownFields.length) {
                    const dropdownValues = [
                            selection.VehicleTypeID,
                            selection.MakeID,
                            selection.ModelID,
                            selection.Year,
                        ];

                    dropdownFields.each(function(index, obj) {
                        const $this = $(this),
                            nextDropdownIndex = index+1;

                        if (dropdownFields.length > nextDropdownIndex) {
                            $this.on('car2db:dropdownLoaded', {
                                nextDropdownIndex: nextDropdownIndex
                            }, (e) => {
                                const nextDropdownIndex = e.data.nextDropdownIndex,
                                    nextDropdown = dropdownFields.eq(nextDropdownIndex),
                                    dropdownValue = forceInt(dropdownValues[nextDropdownIndex]);

                                if (nextDropdown.length) {
                                    if (dropdownValue) nextDropdown.val(dropdownValue).trigger('chosen:updated').trigger('change');
                                    const prevDropdownindex = nextDropdownIndex-1;
                                    if (prevDropdownindex >= 0) {
                                        const prevDropdown = dropdownFields.eq(prevDropdownindex);
                                        if (prevDropdown && prevDropdown.length) {
                                            prevDropdown.off('car2db:dropdownLoaded');
                                        }
                                    }
                                }
                            });
                        }

                    });


                    const firstDropdown = dropdownFields.eq(0);
                    if (firstDropdown.length) {
                        firstDropdown.val(dropdownValues[0]).trigger('chosen:updated').trigger('change');
                    }

                    if (isCustomInput) {
                        dropdownFields.eq(dropdownFields.length-1).val(dropdownValues[dropdownFields.length-1]).trigger('chosen:updated').trigger('change'); // set the year
                        $this.find('.car2db-selects-custom-value-toggle__checkbox').prop('checked', true).trigger('change');
                    }

                }


                // console.log(selection.Options);
                if (selection.Options && selection.Options.length) {
                    selection.Options.forEach(option => {
                        // console.log(option);
                        if (option.ValueFieldType !== 'None') { // if there is also a text input
                            const textFieldID = 'car2db-ms-' + msId + '-option-' + option.OptionID + '-custom-value',
                                textField = $('#' + textFieldID);
                            if (textField.length) {
                                textField.val(option.TextFieldValue);
                                textField.trigger('blur');
                            }
                        }

                        if (option.ValuesFieldType === 'Buttons') {
                            const radioCheckboxFieldID = 'car2db-ms-' + msId + '-option-' + option.OptionID + '-value-' + option.ValueID,
                                radioCheckboxField = $('#' + radioCheckboxFieldID),
                                fieldType = radioCheckboxField.attr('type'); // radio or checkbox
                            if (radioCheckboxField.length) {
                                const labelField = radioCheckboxField.parent('label');
                                labelField.trigger('click');
                            }
                        } else if (option.ValuesFieldType === 'DropDown') {
                            // console.log(option);
                            const selectFieldID = 'car2db-ms-' + msId + '-option-' + option.OptionID,
                                selectField = $('#' + selectFieldID),
                                multiSelect = selectField.attr('multiple');
                            if (selectField.length) {
                                selectField.find('option[value="' + option.ValueID + '"]').prop('selected', true); // so multi selects work
                                if (multiSelect) {
                                    // console.log('trigger chosen:updated');
                                    selectField.trigger('chosen:updated');
                                }
                                selectField.trigger('change');
                            }
                        }
                    });
                }
            }
        }
    };

    const car2dbHideShowNoVehicleCheckbox = function() {
        const car2dbmsCount = $('.car2db-ms').length,
            $car2dbNoVehicleCheckboxWrapper = $('.car2db-no-vehicle-checkbox-wrapper');
        $car2dbNoVehicleCheckboxWrapper.show();
        if (car2dbmsCount > 2) { // if one exists i.e. it's not just the template and add new
            $car2dbNoVehicleCheckboxWrapper.hide();
        }
    };

    const selects = $('.car2db-select');
    if (selects.length) {
        selects.each(function() {
            const $this = $(this),
                panelEl = $this.parents('.panel'),
                msID = forceInt(panelEl.data('car2db-ms-id'));

            if (msID !== -99) {
                $this.chosen({
                    no_results_text: hpaTranslatedtext.car2DB.chosen.noResultsText, // No results found
                    placeholder_text_single: hpaTranslatedtext.car2DB.chosen.placeholderTextSingle, // Please select..
                    disable_search_threshold: 10,
                    width: '100%',
                });
            }
        });
    }


    $('.car2db-select-option').each(function() {
        const $this = $(this),
            panel = $this.parents('.panel'),
            msID = forceInt(panel.data('car2db-ms-id')); // -99 is the template. 0 is the add new form

        if (msID !== -99 && $this.attr('multiple')) {
            $this.chosen({
                no_results_text: hpaTranslatedtext.car2DB.chosen.noResultsText, // No results found
                placeholder_text_single: hpaTranslatedtext.car2DB.chosen.placeholderTextSingle, // Please select..
                disable_search_threshold: 10,
                width: '100%',
            });
        }
    });

    $('.car2db-select, .car2db-custom-value').each(function() {
        const $this = $(this),
            panelEl = $this.parents('.panel'),
            msID = forceInt(panelEl.data('car2db-ms-id'));

        if (msID !== -99) {
            applyParsley($(this));
        }
    });

    $car2db.on('click', '.car2db-btn-submit-selection__button', function() {
        const $this = $(this),
            buttonWrapper = $this.parent('.car2db-btn-submit-selection'),
            panelEl = $this.closest('.panel'),
            panelHeadingEl = panelEl.find('.panel-heading'),
            panelBodyEl = panelEl.find('.panel-body'),
            msID = forceInt(panelEl.data('car2db-ms-id')),
            selectsWrapper = panelEl.find('.car2db-selects'),
            selectFields = selectsWrapper.find('.car2db-select'),
            selectInputFields = selectsWrapper.find('.car2db-select, .car2db-custom-value'),
            loadingFieldWrapper = panelEl.find('.car2db-btn-submit-loader'),
            postData = {};

        let checkFieldsAllValid = true;
        selectInputFields.each(function() {
            const $this = $(this),
                type = getFieldType($this),
                field = getVisibleEl($this);

            if (field.length === 1) {
                // console.log('visible', chosenField.is(':visible'));
                if (field.is(':visible')) {
                    $this.parsley().validate();
                    const isValid = $this.parsley().isValid();
                    if (checkFieldsAllValid) checkFieldsAllValid = isValid; // update it until it is false

                    // console.log({ type, title: $this.data('type'), isValid });
                }
            }
        });
        // console.log({checkFieldsAllValid});
        if (!checkFieldsAllValid) {
            return;
        }

        buttonWrapper.hide();
        loadingFieldWrapper.show();
        postData['MemberSelectionID'] = msID;
        selectInputFields.each(function() {
            const $this = $(this),
                fieldType = getFieldType($this),
                val = fieldType ==='select' ? forceInt($this.val()) : $this.val(),
                type = $this.data('type');
            postData[type] = val;
        });

        postData.SelectedOptions = getSelectedOptions(panelEl);

        // console.log(JSON.stringify(postData));
        // return false;

        $.ajax({
            url: currenLocaleObj.urlPrefix + '/dashboard/garage-json',
            contentType: 'application/json',
            type: 'POST',
            data: JSON.stringify(postData),
            success: function (data) {
                if (data) {
                    loadingFieldWrapper.hide();
                    buttonWrapper.show();
                    if (data.status) {
                        let newPanel = false,
                            panelHeading = false,
                            panelBody = false,
                            makeModelHeadingSection = false,
                            specsHeadingSection = false;
                        // console.log(data);
                        if (msID === 0) {
                            const newMsTemplate = $('#car2db-ms-template .row').clone(),
                                newMsTemplatePanelEl = newMsTemplate.find('.panel'),
                                newMsTemplatePanelHeadingEl = newMsTemplatePanelEl.find('.panel-heading'),
                                newMsTemplatePanelBodyEl = newMsTemplatePanelEl.find('.panel-body');

                            newMsTemplatePanelEl.prop('id', 'car2db-ms-' + data.memberSelectionID).data('car2db-ms-id', data.memberSelectionID);
                            newMsTemplatePanelHeadingEl.data('target', '#car2db-ms-' + data.memberSelectionID + '-panel-body');
                            newMsTemplatePanelBodyEl.prop('id', 'car2db-ms-' + data.memberSelectionID + '-panel-body');
                            newMsTemplate.insertBefore($('#car2db-ms-0').closest('.row'));

                            newPanel = $('#car2db-ms-' + data.memberSelectionID);
                            newPanel.html(function (i, html) {
                               return html.replaceAll('-99', data.memberSelectionID);
                            });
                            panelHeading = newPanel.find('.panel-heading');
                            makeModelHeadingSection = panelHeading.find('.make-model');
                            specsHeadingSection = panelHeading.find('.specs');
                            panelBody = newPanel.find('.panel-body');
                            panelHeading.on('click', function () {
                                panelBody.collapse('toggle');
                            });

                            // update car2DBMemberSelections array so that the new MemberSelection is in it
                            car2DBMemberSelections = data.memberSelections;
                            newPanel.find('.car2db-select-wrapper select').addClass('car2db-select');
                            const newSelectfields = newPanel.find('.car2db-select');
                            newSelectfields.chosen({
                                no_results_text: hpaTranslatedtext.car2DB.chosen.noResultsText, // No results found
                                placeholder_text_single: hpaTranslatedtext.car2DB.chosen.placeholderTextSingle, // Please select..
                                disable_search_threshold: 10,
                                width: '100%',
                            });
                            newSelectfields.each(function() {
                                applyParsley($(this));
                            });

                            const newCustomValueInputFields = newPanel.find('.car2db-custom-value');
                            newCustomValueInputFields.each(function() {
                                applyParsley($(this));
                            });

                            const newSelectOptionfields = newPanel.find('.car2db-select-option');
                            if (newSelectOptionfields.length) {
                                newSelectOptionfields.each(function() {
                                    const $this = $(this);
                                    if ($this.attr('multiple')) {
                                        $this.chosen({ // eslint-disable-line no-unused-vars
                                            no_results_text: hpaTranslatedtext.car2DB.chosen.noResultsText, // No results found
                                            placeholder_text_single: hpaTranslatedtext.car2DB.chosen.placeholderTextSingle, // Please select..
                                            disable_search_threshold: 10,
                                            width: '100%',
                                        });
                                    }
                                });
                            }

                        } else if (msID > 0) {
                            panelHeading = panelEl.find('.panel-heading');
                            panelBody = panelEl.find('.panel-body');
                            makeModelHeadingSection = panelEl.find('.panel-heading .make-model');
                            specsHeadingSection = panelEl.find('.panel-heading .specs');
                        }

                        if (makeModelHeadingSection && makeModelHeadingSection.length) {
                            let makeModelHeading = data.makeTitle + ' ' + data.modelTitle + ' <small>' + data.year + '</small>';
                            makeModelHeadingSection.html(makeModelHeading);
                        }
                        if (specsHeadingSection && specsHeadingSection.length) {
                            specsHeadingSection.html(data.optionsString);
                        }

                        if (panelHeading) {
                            panelHeading.velocity(
                                {
                                    backgroundColor: '#FFB61B'
                                },
                                {
                                    'complete': function(els) {
                                        panelHeading.velocity({
                                            backgroundColor: '#ECEBEA'
                                        });
                                    }
                                }
                            );
                        }

                        if (msID === 0) {
                            updateMemberSelection(newPanel);

                            const customValueCheckbox = panelEl.find('.car2db-selects-custom-value-toggle__checkbox'),
                                customValueInputs = panelEl.find('.car2db-custom-value');
                            customValueCheckbox.prop('checked', false).trigger('change');
                            customValueInputs.val('');

                            // Clear all selections
                            const errorMessageField = panelEl.find('.car2db-selects-error');
                            if (errorMessageField.length) {
                                errorMessageField.text('');
                            }

                            panelEl.find('.car2db-specs').find('input, select').each(function() {
                                const $this = $(this),
                                    fieldType = $this.prop('nodeName').toLowerCase(),
                                    type = (fieldType == 'input' ? $this.attr('type') : fieldType),
                                    multiSelect = ((type === 'checkbox') || (type === 'select' && $this.attr('multiple')) ? true : false);

                                if (type === 'radio' || type === 'checkbox') {
                                    $this.prop('checked', '');
                                    $this.parent('label').removeClass('active');
                                } else if (type === 'text' || type === 'number') {
                                    $this.val('');
                                } else if (type === 'select') {
                                    if (multiSelect) {
                                        $this.find('option').prop('selected', false);
                                        // $this.val('');
                                        $this.trigger('chosen:updated');
                                    } else {
                                        $this.val($this.find('option').first().val());
                                    }
                                }

                                $this.trigger('change');
                            });

                            car2dbHideShowNoVehicleCheckbox();

                        }

                        // console.log(panelEl.offset().top);
                        $('html, body').animate({
                            scrollTop: panelEl.offset().top - 100
                        });

                        panelBodyEl.collapse('hide');
                        panelHeadingEl.addClass('collapsed');
                    }
                }
            },
            dataType: 'json',
        });
    });

    $car2db.on('click', '.car2db-ms .panel-heading .delete .glyphicon-remove-circle', function(e) {
        e.stopPropagation();

        const $this = $(this),
            row = $this.closest('.row'),
            panel = row.find('.panel'),
            panelHeading = panel.find('.panel-heading'),
            makeModelString = panelHeading.find('.make-model').text(),
            id = forceInt(panel.data('car2db-ms-id')),
            act = 'deleteMemberSelection';

        if (!confirm(hpaTranslatedtext.car2DB.confirm.deletePrefix + makeModelString + '?')) return false; // Delete 

        $.get(currenLocaleObj.urlPrefix + '/dashboard/garage-json', { act, id }, function (data) {
            row.fadeOut('slow', function () {
                $(this).remove();

                car2dbHideShowNoVehicleCheckbox();
            });
        }, 'json');
    });

    $car2db.on('change', '.car2db-selects-custom-value-toggle__checkbox', function() {
        const $this = $(this),
            panelEl = $this.parents('.panel'),
            selectWrappers = panelEl.find('.car2db-select-wrapper'),
            selects = panelEl.find('.car2db-select'),
            typeSelect = selects.eq(0),
            makeModelSelects = panelEl.find('.car2db-select-wrapper__select-wrapper'),
            makeModelInputs = panelEl.find('.car2db-select-wrapper__input-wrapper'),
            toggleDiv = $this.parents('.car2db-selects-custom-value-toggle'),
            spanWhenChecked = toggleDiv.find('.car2db-selects-custom-value-toggle__text[data-checkbox-checked="true"]'),
            spanWhenNotChecked = toggleDiv.find('.car2db-selects-custom-value-toggle__text[data-checkbox-checked="false"]'),
            checkbox = toggleDiv.find('.car2db-selects-custom-value-toggle__checkbox'),
            checkboxIsChecked = checkbox.prop('checked'),
            errorEls = panelEl.find('.car2db-select-wrapper__error');

        errorEls.text('').hide();
        // console.log({ checkboxIsChecked });
        if (checkboxIsChecked) {
            clearAllChildren(typeSelect);

            spanWhenChecked.show();
            spanWhenNotChecked.hide();

            makeModelSelects.hide().find('select').removeClass('error');
            makeModelInputs.show().find('input').removeClass('error');

            selectWrappers.show();
        } else {
            typeSelect.trigger('change');

            spanWhenChecked.hide();
            spanWhenNotChecked.show();

            makeModelSelects.show().find('select').removeClass('error');
            makeModelInputs.hide().find('input').removeClass('error');
        }

    });

    $car2db.on('change', '.car2db-select', function() {
        const $this = $(this),
            id = forceInt($this.val()),
            act = $this.data('act'),
            index = forceInt($this.data('index')),
            panelEl = $this.closest('.panel'),
            selectsWrapper = panelEl.find('.car2db-selects'),
            nextSelectField = selectsWrapper.find('.car2db-select[data-index=' + (index+1) + ']'),
            nextSelectFieldParent = nextSelectField.parents('.car2db-select-wrapper'),
            loadingFieldWrapper = panelEl.find('.car2db-selects-loader'),
            buttonWrapper = panelEl.find('.car2db-btn-submit-selection'),
            customValuesToggleDiv = panelEl.find('.car2db-selects-custom-value-toggle'),
            customValuesCheckbox = customValuesToggleDiv.find('.car2db-selects-custom-value-toggle__checkbox'),
            customValuesCheckboxIsChecked = customValuesCheckbox.prop('checked'),
            typeSelectField = panelEl.find('.car2db-type-select');

        $this.parsley().validate();
        // console.log({ customValuesCheckboxIsChecked });

        if (typeSelectField.val()) {
            customValuesToggleDiv.show();
        } else {
            customValuesToggleDiv.hide();
        }
        panelEl.find('.car2db-selects-custom-value-toggle__text').hide();
        panelEl.find('.car2db-selects-custom-value-toggle__text[data-checkbox-checked="' + (customValuesCheckboxIsChecked ? 'true' : 'false') + '"]').show();

        if (customValuesCheckboxIsChecked) {

        } else {
            // buttonWrapper.hide();
            clearAllChildren($this);

            if (nextSelectField.length && id) {
                if (act) {
                    loadingFieldWrapper.show();
                    nextSelectField.find('option').remove();
                    nextSelectField.trigger('chosen:updated');

                    $.get(currenLocaleObj.urlPrefix + '/dashboard/garage-json', { act, id }, function (data) {
                        if (data) {
                            nextSelectField.data('options-count', data.length);
                            if (data.length) {
                                nextSelectField.find('option').remove();
                                nextSelectField.append('<option value="">' + hpaTranslatedtext.car2DB.dropdown.selectPlaceholderPrefix + nextSelectField.data('title') + '...' + '</option>'); // Select ...
                                data.forEach(function(option) {
                                    nextSelectField.append('<option value="' + option.value + '">' + option.text + '</option>');
                                });
                                nextSelectFieldParent.show();
                            }

                            nextSelectField.trigger('chosen:updated');
                            loadingFieldWrapper.hide();
                            const complete = selectionCompleteCheck($this);
                            // console.log('selectionCompleteCheck:', complete);
                            if (complete) {
                                // console.log('showing add button');
                                // buttonWrapper.show();
                            }

                            $this.trigger('car2db:dropdownLoaded');
                        }
                    }, 'json');
                } else { // The Years select fields are already populated so don't need to do a ajax request
                    nextSelectFieldParent.show();
                    nextSelectField.trigger('chosen:updated');
                    $this.trigger('car2db:dropdownLoaded');
                }
            } else { // it's the last one
                if (selectionCompleteCheck($this)) {
                    // buttonWrapper.show();
                }
            }
        }
    });

    $car2db.on('change', '.car2db-spec__options input, .car2db-spec__options select', function() {
        const $this = $(this),
            panelEl = $this.closest('.panel'),
            optionsDiv = $this.closest('.car2db-spec__options'),
            optionID = (optionsDiv ? forceInt(optionsDiv.data('option-id')) : 0);

        if (optionID > 0) {
            dependentOptionsToggle(panelEl);
            const valuesDiv = panelEl.find('.js-car2db-spec__selected-values[data-option-id="' + optionID + '"]');

            if (valuesDiv) {
                let valuesString = '';
                optionsDiv.find('input').each(function() {
                    const $this = $(this),
                        type = $this.attr('type'),
                        selected = $this.prop('checked'),
                        optionID = forceInt($this.data('option-id'));
                    let value = '',
                        valueID = 0,
                        textFieldValue = '';
                    // console.log({ type, selected });
                    if ((type === 'radio' || type === 'checkbox') && selected) {
                        value = $this.data('title');
                        valueID = forceInt($this.val());
                        // console.log({ value, valueID });
                    } else if (type === 'text' || type === 'number') {
                        value = $this.val();
                        textFieldValue = value;
                    }

                    if (value) {

                        // const option = {
                        //     optionID: optionID,
                        //     valueID: valueID,
                        //     value: textFieldValue,
                        // };
                        // const selectedOption = selectedOptions.find((selectedOption) => selectedOption.optionID === optionID);
                        // if (selectedOption) {
                        //     selectedOption.optionID = option.optionID;
                        //     selectedOption.valueID = option.valueID;
                        //     selectedOption.value = option.value;
                        //
                        // } else {
                        //     selectedOptions.push(option);
                        // }

                        if (valuesString !== '') valuesString += ' | ';
                        valuesString += value;
                    }
                });

                optionsDiv.find('select').each(function() {
                    const $this = $(this),
                        selectedOptions = $this.find('option:selected'),
                        optionID = forceInt($this.data('option-id'));

                    selectedOptions.each(function() {
                        const valueID = forceInt($(this).val()),
                            valueText = $(this).text();

                        if (valueID) {
                            if (valuesString !== '') valuesString += ' | ';
                            valuesString += valueText;
                        }

                        // const option = {
                        //     optionID: optionID,
                        //     valueID: valueID,
                        //     value: '',
                        // };
                        // const selectedOption = selectedOptions.find((selectedOption) => selectedOption.optionID === optionID);
                        // if (selectedOption) {
                        //     selectedOption.optionID = option.optionID;
                        //     selectedOption.valueID = option.valueID;
                        // } else {
                        //     selectedOptions.push(option);
                        // }
                    });
                });

                valuesDiv.html(valuesString);
            }
        }

    });

    const $car2DBNoVehiclesCheckbox = $('.car2db-no-vehicle-checkbox');
    if ($car2DBNoVehiclesCheckbox.length) {
        $car2DBNoVehiclesCheckbox.on('click', function() {
            const $this = $(this),
                id = $this.attr('id');
            let value = 0;

            if ($this.is(':checked')) {
                value = 1;
                $car2db.hide();
            } else {
                $car2db.show();
            }

            if (id !== 'ProfileCompleteForm_ProfileCompleteForm_Car2DBNoVehicles') { // Don't want to do this on the page /account/profile.
                $.get(currenLocaleObj.urlPrefix + '/dashboard/garage-json', 'act=updateCar2DBNoVehicles&value=' + value, function(data) {
                    // console.log(data);
                });
            }
        });
    }

    updateMemberSelections();
});



// WEBPACK FOOTER //
// ./js/modules/car2DB.js